export default function XML_DTD() {
  return (
    <div>
      <h1>XML_DTD</h1>
      <p>This is the XML_DTD component.</p>
    </div>
  );
}